import { Organization } from 'types/organization.type';
import { useContext } from 'react';
import { InstallationProviderContext } from 'application/Providers/Installation';
import * as React from 'react';

export interface ProducerDashboardProps {
    producer?: Organization;
    productLineCode?: string;
    submissionId?: string;
}

const LrProducerDashboard = (props: ProducerDashboardProps) => {
    const installationProvider = useContext(InstallationProviderContext);
    const DashboardComponent = installationProvider.getProducerDashboardComponenet();
    return <DashboardComponent {...props} />;
};

export default LrProducerDashboard;

export { default as PPLrProducerDashboard } from './components/PPLrProducerDashboard';
export { default as BRLrProducerDashboard } from './components/BRLrProducerDashboard';
